import { render, staticRenderFns } from "./TeamActions.vue?vue&type=template&id=b8b179f8&scoped=true&"
import script from "./TeamActions.vue?vue&type=script&lang=js&"
export * from "./TeamActions.vue?vue&type=script&lang=js&"
import style0 from "./TeamActions.vue?vue&type=style&index=0&id=b8b179f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b179f8",
  null
  
)

export default component.exports